import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type State = {
  list: [];
};

export const churchSlice = createSlice({
  name: 'church',
  initialState: {
    list: [],
  } as State,
  reducers: {
    receivedList: (state, action: PayloadAction<{ churches: [] }>) => {
      state.list = action.payload.churches;
    },
  },
});
